import { jsx as _jsx } from "react/jsx-runtime";
import { TransportContext } from '#pplx/frontend/framework/instrumentation/internal/TransportContext.js';
import { NOOP_INSTRUMENTATION_CONFIG } from '#pplx/frontend/framework/instrumentation/types.js';
import { useMemo, useState } from 'react';
import { memo } from 'react';
/**
 * Establishes the root of the instrumentation scope tree and holds the
 * mutable transport config. Descendants read the config (and request runtime
 * updates) via `useInstrumentation()`. When no real config has been installed,
 * the no-op default keeps `track()` calls on a single, side-effect-free path.
 */
export const InstrumentationRoot = memo(function InstrumentationRoot({ initialConfig = NOOP_INSTRUMENTATION_CONFIG, children, }) {
    const [config, configure] = useState(initialConfig);
    // Memoize the value object so children don't see a new reference on
    // renders that didn't change config. The setter from useState is already
    // stable per React's contract.
    const value = useMemo(() => ({ config, configure }), [config]);
    return _jsx(TransportContext.Provider, { value: value, children: children });
});
//# sourceMappingURL=InstrumentationRoot.js.map